import { getApiConfig } from '@/api/config/client/getApiConfig';
import { ProductHeaders } from '@/api/headers';
import { ApiLogger } from '@/api/logger/apiLogger';
import { osDetector } from '@/api/osDetector/client';
import { type KeyGenHeader, type KeyGenRequest, type KeyGenResponse } from '@/api/types/keyGenTypes';

import { type ConfigClient, configClient } from './configClient';
import { HttpClient, type HttpOptions } from './httpClient';

const apiConfig = getApiConfig();
const { apiKey, isLogEnabled, productBaseUrl } = apiConfig;

export class KeyGenClient {
  private readonly configClient: ConfigClient;

  public constructor(
    private readonly httpClient: HttpClient,
    protected readonly logger: ApiLogger,
    cClient: ConfigClient,
  ) {
    this.configClient = cClient;
  }

  public async getHeaders(keyGenRequest: KeyGenRequest = {}, options?: HttpOptions): Promise<KeyGenHeader[]> {
    const config = await this.configClient.getConfig();

    const uri = config.template_uris.keygen_uri;

    const data = await this.httpClient.post<KeyGenResponse>(uri, keyGenRequest, options);

    return data?.headers ?? [];
  }
}

const logger = new ApiLogger('KeyGenClient', isLogEnabled);
const headers = new ProductHeaders(apiKey);
const httpClient = new HttpClient({ apiConfig, baseUrl: productBaseUrl, headers, logger, osDetector });

export const keyGenClient = new KeyGenClient(httpClient, logger, configClient);
